import Axios from 'axios';
import i18n from '@/i18n'
import { httpAPI } from "@/api/httpAPI";
import sys from '@/services/system';
import _ from 'lodash'

/**
 * Модуль attachments
 */
const attachments = {
    namespaced: true,    
    state: {
        updateCancelTokenSource: null,
        dataSource: [],
        currentDocumentId: null,
        selectedAttachmentId: null,
        loadingAttachments: {},
        previewSrc: "",
    },
    mutations: {
        ADD_LOADIGN_ATTACHMENT(state, payload) {
            
            if (!state.loadingAttachments[payload.id])
                state.loadingAttachments[payload.id] = [];

            let data = state.loadingAttachments[payload.id];
            
            if (!data.find(i => i.Id == payload.attachment.Id))
                data.push(payload.attachment);
        },
        DEL_LOADIGN_ATTACHMENT(state, payload) {
            
            if (!state.loadingAttachments[payload.id])
                return;

            var data = state.loadingAttachments[payload.id]
            var item = data.find(i => i.Id == payload.attachment.Id);

            if (item)
            {
                data.splice(data.indexOf(item), 1);

                if (data.length == 0)
                    delete state.loadingAttachments[payload.id];
            }
        },
        SET_CURRENT_DOCUMENT_ID(state, payload) {
            state.currentDocumentId = payload.id;
        },
        SET_SELECTED_ATTACHMENT_ID(state, payload){
            state.selectedAttachmentId = payload;
        },
        SET_DATASOURCE(state, payload) {
            state.dataSource = payload.dataSource;
        },
        PUSH_DATASOURCE(state, payload) {
            if (!state.dataSource.find(i => i.id == payload.attachment.Id))
                state.dataSource.push(payload.attachment);
        },
        SET_UPDATE_CANCEL_TOKENSOURCE(state, payload) {
            state.updateCancelTokenSource = payload.updateCancelTokenSource;
        },
        SET_PREVIEW_SRC(state, payload) {
            state.previewSrc = payload.previewSrc;
        },
        UPDATE_lOADING_ATTACHMENT(state, payload)
        {
            this._vm.$_.set(state.loadingAttachments, payload.property, payload.value)
        }
    },
    actions: {  
        setPreviewSrc({ commit }, previewSrc) {
            commit({ type: 'SET_PREVIEW_SRC', previewSrc });
        },
        addLoadingAttachment({ commit }, { id, attachment }) {
            commit({ type: 'ADD_LOADIGN_ATTACHMENT', id, attachment });
        },
        delLoadingAttachment({ commit }, { id, attachment }) {
            commit({ type: 'DEL_LOADIGN_ATTACHMENT', id, attachment });
        },
        async deleteAttachment({ state, commit, dispatch, getters, rootGetters }, attachment) {
            // если у файла есть что-то в этом поле, мы расцениваем его как не загруженный / вложенный и не спрашиваем подтверждения
            if (attachment.Message) {
                let tempDataSource = Array.from(state.dataSource).filter(it => it.Id != attachment.Id);
                await commit('SET_DATASOURCE', { dataSource: tempDataSource });                        
                await dispatch({ type: 'delLoadingAttachment', id: state.currentDocumentId, attachment });
                return;
            }
            
            let isMeeting = rootGetters['global/actionsource/getDataSourceFullType'] === 'Meeting:#Avrora.Objects.Modules.Meetings';
            let isPlannedMeeting = rootGetters['global/actionsource/getDataSourceFullType'] === 'PlannedMeeting:#Avrora.Objects.Modules.Planned';

            let methodName = "actions/deleteattachment";
            
            if (isMeeting)
                methodName = "eventmanagement/deletemeetingattachment";

            if (isPlannedMeeting)
                methodName = "plannedevent/deleteplannedmeetingattachment";

            this._vm.$notify.confirm(
                i18n.t('Вы_действительно_хотите_удалить_вложение_filename?.message', { filename: attachment.Name }),
                async () => {
                    attachment.Message = i18n.t("Удаление...");
                    try {
                        let response = await httpAPI({
                            url: `/api/${methodName}?id=${attachment.Id}`,
                            method: 'GET',
                            headers: { 'Content-Type': 'application/json; charset=utf-8', 'isCommon': rootGetters['global/actionsource/isDataSourceCommon'] },
                        });

                        if (response) {
                            let tempDataSource = Array.from(state.dataSource).filter(it => it.Id != attachment.Id);
                            
                            if (attachment.Id == state.selectedAttachmentId)
                                commit('SET_SELECTED_ATTACHMENT_ID', null);
                                //commit({ type: 'SET_PREVIEW_SRC', previewSrc: '' });

                            await commit('SET_DATASOURCE', { dataSource: tempDataSource });
                            await dispatch({ type: 'delLoadingAttachment', id: state.currentDocumentId, attachment });

                            if (isMeeting || isPlannedMeeting) {
                                await dispatch('global/actionsource/updateDataSource', { property: `Data.Object.AttachmentsSource`, value: tempDataSource }, { root: true });
                                return;
                            }

                            if (getters.getDocumentAttachmentsCount == 0) {
                                dispatch('global/actionsource/updateDocument', null, { root: true });
                            }
                            else {
                                let currEntityDataSource = rootGetters['global/actionsource/getDataSource'];
                                let index = _.findIndex(currEntityDataSource?.Data?.Object?.Pages, function(page) { return page.FormId === '0202010' });
                                let path = `Data.Object.Pages[${index}].Count`;
                                let count = _.get(currEntityDataSource, path);
                                dispatch('global/actionsource/updateDataSource', { property: path, value: count - 1 }, { root: true });
                            }
                        }
                        else {
                            attachment.Message = null;
                        }
                    }
                    catch
                    {
                        attachment.Message = null;
                    }
                }
            )
        },
        async onFilePicked({ state, commit, getters, dispatch, rootGetters }, {e}) { 
            let isIqalaStetment = rootGetters['global/actionsource/getDataSourceFullType'] === 'IQalaStatement:#Avrora.Objects.Modules.Docflow.DocflowObjects';
            let isOrder = rootGetters['global/actionsource/getDataSourceFullType'] === 'Order:#Avrora.Objects.Modules.Docflow.DocflowObjects';
            let isMeeting = rootGetters['global/actionsource/getDataSourceFullType'] === 'Meeting:#Avrora.Objects.Modules.Meetings';
            let isPlannedMeeting = rootGetters['global/actionsource/getDataSourceFullType'] === 'PlannedMeeting:#Avrora.Objects.Modules.Planned';

            commit('documents/toolbar/SET_ISLOCK', { isLock: true }, { root: true });

            var needDocumentReload = getters.getDocumentAttachmentsCount == 0;
            await Promise.all(Array.from(e.target.files).map( async (f) => {
                    
                let attachment = sys.prepareAttachment(f, state.dataSource, this._vm.$notify);
                
                if (isIqalaStetment)
                    attachment.Group = 5;
                await commit('global/attachments/ADD_LOADIGN_ATTACHMENT', { id: state.currentDocumentId, attachment: attachment }, { root: true })
                await commit('global/attachments/PUSH_DATASOURCE', { attachment }, { root : true });                
                if (attachment.Message)
                    return;

                let formData = new FormData();
                formData.append('file', f);

                try 
                {
                    let saveAttachmentType = "actions/saveattachment";

                    if (isOrder)
                        saveAttachmentType = "actions/saveorderattachment";
                    
                    if (isMeeting)
                        saveAttachmentType = "eventmanagement/savemeetingattachment";
                    
                    if (isPlannedMeeting)
                        saveAttachmentType = "plannedevent/saveplannedmeetingatachment";
                    let response = await httpAPI({
                        url: `/api/${saveAttachmentType}?id=${state.currentDocumentId}&fileName=${attachment.Name}&fileSize=${attachment.Length}`,
                        method: 'POST',
                        data: formData,
                        headers: { 'Content-Type': 'multipart/form-data', 'isCommon': rootGetters['global/actionsource/isDataSourceCommon'] },
                        onUploadProgress: (progressEvent) => {
                            let attach = getters.getLoadingAttachmnets[state.currentDocumentId].find(i => i.Id == attachment.Id);
                            let index = getters.getLoadingAttachmnets[state.currentDocumentId].indexOf(attach);
                            let progress = `${Math.trunc((100/progressEvent.total)*progressEvent.loaded)}%`;
                            if (attachment.Progress != progress)
                                commit('UPDATE_lOADING_ATTACHMENT', {property: `${state.currentDocumentId}[${index}].Progress`, value: progress });                            
                        },
                        skipErrorHandler: true
                    });
                    if (response.data.Success && response.data.Payload.Result == "OK")
                    {
                        await commit('global/attachments/DEL_LOADIGN_ATTACHMENT', { id: state.currentDocumentId, attachment: attachment }, { root: true });
                        let tempDataSource = state.dataSource.map(x => x);
                        tempDataSource.splice(tempDataSource.indexOf(attachment), 1);
                        tempDataSource.push(response.data.Payload.Data.Object);
                        await commit('global/attachments/SET_DATASOURCE', { dataSource: tempDataSource }, { root: true });
                        this._vm.$notify.success(i18n.t('Файл_filename_успешно_загружен.message', {filename: attachment.Name}));
                        if (isMeeting || isPlannedMeeting){
                            await dispatch('global/actionsource/updateDataSource', { property: `Data.Object.AttachmentsSource`, value: tempDataSource }, { root: true });
                            this._vm.$eventBus.$emit('update-active-tab');
                        }
                        commit('SET_SELECTED_ATTACHMENT_ID', response.data.Payload.Data.Object.Id);
                    }
                    else
                    {
                        let dsAttachment = state.dataSource.find(x => x.Id == attachment.Id);

                        if (dsAttachment) {
                            dsAttachment.Message = response.data.Success ? response.data.Payload.Message : response.data.Message;
                            delete dsAttachment.Progress;
                        }

                        await commit('global/attachments/SET_DATASOURCE', { dataSource: state.dataSource.map(x => x) }, { root: true });
                        this._vm.$notify.alert(i18n.t('Ошибка_загрузки_файла:_filename_with_reason.message', { filename: attachment.Name, reason: response.data.Success ? response.data.Payload.Message : response.data.Message }));
                    }
                }
                catch (exception) 
                {
                    let dsAttachment = state.dataSource.find(x => x.Id == attachment.Id);

                    if (dsAttachment) {
                        dsAttachment.Message = Axios.isCancel(exception) ? i18n.t('Загрузка_отменена') : i18n.t('Ошибка_загрузки_файла');
                        delete dsAttachment.Progress;
                    }

                    attachment.CancelTokenSource.cancel();
                    await commit('global/attachments/SET_DATASOURCE', { dataSource: state.dataSource.map(x => x) }, { root: true });
                    this._vm.$notify.alert(i18n.t('Ошибка_загрузки_файла:_filename.message', { filename: attachment.Name }));
                }
            }));

            e.target.value = null;
            if (getters.getDocumentAttachmentsCount > 0 && !isMeeting && !isPlannedMeeting) {
                if (needDocumentReload) {
                    dispatch('global/actionsource/updateDocument', null, { root: true });
                }
                else {
                    let currEntityDataSource = rootGetters['global/actionsource/getDataSource'];
                    let index = _.findIndex(currEntityDataSource?.Data?.Object?.Pages, function(page) { return page.FormId === '0202010' });
                    let path = `Data.Object.Pages[${index}].Count`;
                    dispatch('global/actionsource/updateDataSource', { property: path, value: getters.getDocumentAttachmentsCount }, { root: true });
                }
            }
            
            commit('documents/toolbar/SET_ISLOCK', { isLock: false }, { root: true })
        },

        async updateAttachment({ state, commit, getters, rootGetters }, {arrayBuffer, attachmentId}) { 
            commit('documents/toolbar/SET_ISLOCK', { isLock: true }, { root: true });
            let attachment = state.dataSource.find(it => it.Id == attachmentId);
            let result = false;
            if (!attachment){
                this._vm.$notify.alert(i18n.t('Вложение_не_найдено'));
            }
            else if (!sys.checkAttachmentSize(arrayBuffer.byteLength)){
                this._vm.$notify.alert(i18n.t("Превышен_лимит_размера_вложения_limit.message", { limit: '15 Мб' }));
            }
            else {
                await commit('global/attachments/ADD_LOADIGN_ATTACHMENT', { id: state.currentDocumentId, attachment }, { root: true })

                const formData = new FormData();
                const blob = new Blob([arrayBuffer], {
                    type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                });
                formData.append('file', blob, attachment.Name);
                formData.append('attachmentId', attachmentId);
                formData.append('documentId', state.currentDocumentId);
                try 
                {
                    let response = await httpAPI({
                        url: `/api/actions/updateattachment`,
                        method: 'POST',
                        data: formData,
                        headers: { 'Content-Type': 'multipart/form-data', 'isCommon': rootGetters['global/actionsource/isDataSourceCommon'] },
                        onUploadProgress: (progressEvent) => {
                            let attach = getters.getLoadingAttachmnets[state.currentDocumentId].find(i => i.Id == attachmentId);
                            let index = getters.getLoadingAttachmnets[state.currentDocumentId].indexOf(attach);
                            let progress = `${Math.trunc((100/progressEvent.total)*progressEvent.loaded)}%`;
                            if (attachment.Progress != progress)
                                commit('UPDATE_lOADING_ATTACHMENT', {property: `${state.currentDocumentId}[${index}].Progress`, value: progress });                            
                        },
                        skipErrorHandler: true
                    });
                    if (response.data.Success && response.data.Payload.Result == "OK")
                    {
                        await commit('global/attachments/DEL_LOADIGN_ATTACHMENT', { id: state.currentDocumentId, attachment }, { root: true });
                        attachment.Length = arrayBuffer.byteLength;
                        attachment.RecDate = this._vm.$moment(Date.now()).format('DD.MM.YYYY HH:mm:ss');
                        delete attachment.Progress;
                        this._vm.$notify.success(i18n.t('Файл_filename_успешно_обновлен.message', {filename: attachment.Name}));
                        result = true;
                    }
                    else
                    {
                        let dsAttachment = state.dataSource.find(x => x.Id == attachment.Id);

                        if (dsAttachment) {
                            dsAttachment.Message = response.data.Success ? response.data.Payload.Message : response.data.Message;
                            delete dsAttachment.Progress;
                        }

                        this._vm.$notify.alert(i18n.t('Ошибка_загрузки_файла:_filename_with_reason.message', { filename: attachment.Name, reason: response.data.Success ? response.data.Payload.Message : response.data.Message }));
                    }
                }
                catch (exception) 
                {
                    let dsAttachment = state.dataSource.find(x => x.Id == attachment.Id);

                    if (dsAttachment) {
                        dsAttachment.Message = Axios.isCancel(exception) ? i18n.t('Загрузка_отменена') : i18n.t('Ошибка_загрузки_файла');
                        delete dsAttachment.Progress;
                    }

                    attachment.CancelTokenSource.cancel();
                    await commit('global/attachments/SET_DATASOURCE', { dataSource: state.dataSource.map(x => x) }, { root: true });
                    this._vm.$notify.alert(i18n.t('Ошибка_загрузки_файла:_filename.message', { filename: attachment.Name }));

                }
            }
            commit('documents/toolbar/SET_ISLOCK', { isLock: false }, { root: true })
            return result;
        },

        setCurrentDocumentId({ commit }, id) {
            commit({ type: 'SET_CURRENT_DOCUMENT_ID', id });
        },
        setDataSource({commit}, dataSource) {
            commit({ type: 'SET_DATASOURCE', dataSource });
        },
        async updateDataSource({ state, commit, rootGetters }) {
            commit('SET_SELECTED_ATTACHMENT_ID', null);
            if (state.updateCancelTokenSource)
                state.updateCancelTokenSource.cancel('New request started');

            commit({ type: 'SET_UPDATE_CANCEL_TOKENSOURCE', updateCancelTokenSource: Axios.CancelToken.source() })

            let objType = rootGetters['global/actionsource/getDataSourceType'];
            let response = objType === 'Meeting' || objType === 'PlannedMeeting'
                ? { data: { Payload: rootGetters['global/actionsource/getDataSourceEntity']?.AttachmentsSource ??  []  } }
                : await httpAPI({
                        url: `api/tabs/${objType === 'Order' || objType === 'Resolution' ? 'resolution' : ''}attachments/${state.currentDocumentId}`,
                        method: 'GET',
                        headers: { 'isCommon': rootGetters['global/actionsource/isDataSourceCommon'] },
                    });
            if (response) {
                var loadingAttachments = state.loadingAttachments[state.currentDocumentId] ?? [];
                var data = response.data.Payload;
                
                if (loadingAttachments.length > 0)
                    data = data.concat(loadingAttachments);
                
                commit({type: 'SET_DATASOURCE', dataSource: data });
            }
            else
                commit({type: 'SET_DATASOURCE', dataSource: [] });
        },
        async renameAttachment({ state, rootGetters}, {attachmentId, newName} ){
            let result = false;
            let attachment = state.dataSource.find(it => it.Id == attachmentId);
            if (attachment){
                let response = await httpAPI({
                    url: `api/actions/renameattachment`,
                    method: 'POST',
                    headers: { 'isCommon': rootGetters['global/actionsource/isDataSourceCommon'] },
                    data: { Content : JSON.stringify({ id: attachmentId, newName : newName })},
                });
                if (response.data.Success && response.data.Payload.Result == "OK"){
                    attachment.Name = newName;
                    this._vm.$notify.success(i18n.t('Файл_переименован'));
                    result = true;
                }
            }
            return result;
        },
        validateFile(_, file) {
            if (file.name.length > sys.MAX_FILE_NAME_CHAR_COUNT)
                return { success: false, message: i18n.t("Превышена_допустимая_длина_имени_файла_limit.message", { limit: sys.MAX_FILE_NAME_CHAR_COUNT }) };

            if (sys.FORBIDDEN_SEQUENCES.some(seq => file.name.includes(seq)))
                return { success: false, message: i18n.t("Недопустимое_имя_файла") };

            if (file.size > sys.MAX_FILE_SIZE)
                return { success: false, message: i18n.t("Превышен_лимит_размера_вложения_limit.message", { limit: '15 Мб' }) };

            var fileExtention = file.name.match(new RegExp('[^.]+$'))[0].toLowerCase();

            if (sys.FORBIDDEN_EXTENSIONS.includes(fileExtention))
                return { success: false, message: i18n.t("Недопустимое_расширение_файла") };

            return { success: true, message: null };
        }
    },
    getters: {
        getLoadingAttachmnets: s => s.loadingAttachments,
        getCurrentDocumentId: s => s.currentDocumentId,
        getSelectedAttachmentId: s => s.selectedAttachmentId,
        getDataSource: s => s.dataSource,
        getDocumentAttachmentsCount: s => {            
            return s.dataSource.reduce((acc, item) => {
                if (!!item.Message || !!item.Progress)
                    return acc;
                else
                    return ++acc;
                }, 0);                
        },
        getPreviewSrc: s => s.previewSrc,
        getForbiddenExtensions: () => sys.FORBIDDEN_EXTENSIONS,
        getMaxFileSize: () => sys.MAX_FILE_SIZE,
        getMaxFilesSize: () => sys.MAX_FILES_SIZE,
        getMaxFilesCount: () => sys.MAX_FILE_COUNT,
        getMaxFileNameCharCount: () => sys.MAX_FILE_NAME_CHAR_COUNT,
        getFileExtensionsAssociationIcons: () => {
            return {
                pdf: 'fas fa-file-pdf',
                jpg: 'fas fa-file-image',
                jpeg: 'fas fa-file-image',
                png: 'fas fa-file-image',
                doc: 'fas fa-file-word',
                docx: 'fas fa-file-word',
                xls: 'fas fa-file-excel',
                xlsx: 'fas fa-file-excel',
                rar: 'fas fa-file-archive',
                zip: 'fas fa-file-archive',
                '7z': 'fas fa-file-archive',
                ppt: 'fas fa-file-powerpoint',
                pptx: 'fas fa-file-powerpoint',
                csv: 'fas fa-file-csv',
                odt: 'fas fa-file-word',
                rtf: 'fas fa-file-word',
                ods: 'fas fa-file-excel',
                txt: 'fas fa-file-alt'
            }
        },
        getFileExtensionsAssociationIconsColors: () => {
            return {
                pdf: '#ba141a',
                jpg: '#662d91',
                jpeg: '#662d91',
                png: '#662d91',
                doc: '#0054a6',
                docx: '#0054a6',
                xls: '#008641',
                xlsx: '#008641',
                ppt: '#f04e23',
                pptx: '#f04e23',
                csv: '#008641',
                ods: '#008641',
                odt: '#0054a6',
                rtf: '#0054a6',
                txt: '#0054a6',
            }
        },
    },
};

export default attachments;
